import { render, staticRenderFns } from "./recommend-colors.vue?vue&type=template&id=6ed42290&"
import script from "./recommend-colors.vue?vue&type=script&lang=js&"
export * from "./recommend-colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed42290')) {
      api.createRecord('6ed42290', component.options)
    } else {
      api.reload('6ed42290', component.options)
    }
    module.hot.accept("./recommend-colors.vue?vue&type=template&id=6ed42290&", function () {
      api.rerender('6ed42290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/color-picker/recommend-colors.vue"
export default component.exports